import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

export interface UserProfile {
    fullName: string;
    firstName: string;
    lastName: string;
    email: string;
    organizations: { organizationName: string; supplierNpi: string; role: string }[];
}

export interface AuthSliceState {
    accessToken?: string;
    selectedNpi?: string;
    permissions: string[];
    analyticsAccess: boolean;
    supplierFeatures?: string[];
    profile?: UserProfile;
}

const initialState: AuthSliceState = {
    accessToken: undefined,
    selectedNpi: undefined,
    permissions: [],
    analyticsAccess: false,
    supplierFeatures: undefined,
    profile: undefined,
};

export const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        setAccessToken(
            state,
            action: PayloadAction<{
                accessToken: string;
                selectedNpi: string;
                permissions: string[];
                analyticsAccess: boolean;
            }>,
        ) {
            const { accessToken, permissions, analyticsAccess } = action.payload;
            return { ...state, accessToken, permissions, analyticsAccess };
        },
        setNpi(
            state,
            action: PayloadAction<{
                accessToken: string;
                selectedNpi: string;
                permissions: string[];
                analyticsAccess: boolean;
            }>,
        ) {
            const { accessToken, selectedNpi, permissions, analyticsAccess } = action.payload;
            return {
                ...state,
                accessToken,
                selectedNpi,
                permissions,
                analyticsAccess,
            };
        },
        setSupplierFeatures(state, action: PayloadAction<{ supplierFeatures: string[] }>) {
            const { supplierFeatures } = action.payload;
            return { ...state, supplierFeatures };
        },
        setProfile(state, action: PayloadAction<{ profile: UserProfile }>) {
            const { profile } = action.payload;
            return {
                ...state,
                profile,
            };
        },
    },
});

export const { setAccessToken, setNpi, setSupplierFeatures, setProfile } = authSlice.actions;
